(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["castlefit-full-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cf-full-video')) {
    customElements.define(
      'cf-full-video',
      class extends HTMLElement {
        connectedCallback() {
          this.playButton = this.querySelector('[data-play]');
          if (!this.playButton || this.playButton.disabled) return;
          this.playButton.addEventListener('click', () => this.play());
        }

        play() {
          if (this.classList.contains('is-playing')) return;
          this.classList.add('is-playing');

          const video = this.querySelector('.cf-full-video__el');
          if (video) {
            video.setAttribute('controls', '');
            video.play();
            return;
          }

          const template = this.querySelector('template');
          const embed = this.querySelector('[data-embed]');
          if (template && embed) {
            embed.appendChild(template.content.cloneNode(true));
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["castlefit-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cf-reviews')) {
    customElements.define(
      'cf-reviews',
      class extends HTMLElement {
        connectedCallback() {
          this.slides = Array.from(this.querySelectorAll('[data-slide]'));
          this.dots = Array.from(this.querySelectorAll('[data-dot]'));
          this.dots.forEach((dot, index) => {
            dot.addEventListener('click', () => this.go(index));
          });
        }

        go(index) {
          this.slides.forEach((slide, i) => {
            slide.hidden = i !== index;
          });
          this.dots.forEach((dot, i) => {
            if (i === index) {
              dot.setAttribute('aria-current', 'true');
            } else {
              dot.removeAttribute('aria-current');
            }
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
